import React from 'react';
import { StatusBadge } from './StatusBadge';
import { getStatusMeta, getPriorityMeta, getInitials, formatRelativeTime } from '../utils/format';
import styles from './TaskCard.module.css';

export function TaskCard({ task, branchMeta, onClick }) {
  const statusMeta = getStatusMeta(task.status);
  const priorityMeta = getPriorityMeta(task.priority);

  return (
    <article
      className={`${styles.card} ${styles[`priority--${task.priority}`]}`}
      style={{ borderLeftColor: priorityMeta.color }}
      onClick={() => onClick(task.id)}
      role="button"
      tabIndex={0}
      aria-label={`Task: ${task.title}, ${task.progress ?? 0}% complete, ${task.status}`}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick(task.id);
        }
      }}
    >
      <div className={styles.header}>
        <h3 className={styles.title}>{task.title}</h3>
        <div className={styles.meta}>
          {branchMeta && (
            <span
              className={styles.branchBadge}
              style={{
                backgroundColor: `${branchMeta.color}12`,
                color: branchMeta.color,
              }}
            >
              {task.branch}
            </span>
          )}
          <span className={styles.updated}>{formatRelativeTime(task.updated_at)}</span>
        </div>
      </div>

      <div className={styles.body}>
        <div className={styles.assignee}>
          <span
            className={styles.assigneeAvatar}
            style={{
              backgroundColor: `${branchMeta?.color || '#94a3b8'}20`,
              color: branchMeta?.color || '#94a3b8',
            }}
          >
            {getInitials(task.assigned_to)}
          </span>
          <span className={styles.assigneeName}>{task.assigned_to}</span>
        </div>
        <StatusBadge status={task.status} />
      </div>

      <div className={styles.footer}>
        <div className={styles.progressBar}>
          <div
            className={styles.progressFill}
            style={{
              width: `${task.progress ?? 0}%`,
              backgroundColor: statusMeta.color,
            }}
          />
        </div>
        <span className={styles.progressText}>{task.progress ?? 0}%</span>
      </div>
    </article>
  );
}
